import { ScrollSmoother } from 'gsap/ScrollSmoother';
import { navigate } from 'gatsby';

/**
 * Scrolls to the schedule-your-meeting element with retry logic and ScrollSmoother support
 * Handles cases where the element might not be immediately available due to animations
 */
export const scrollToScheduleMeeting = () => {
  let retryCount = 0;
  const maxRetries = 15; // Max 3 seconds of retries
  const retryDelay = 200;

  const attemptScroll = () => {
    const targetElement = document.getElementById('schedule-your-meeting');
    const smoother = ScrollSmoother.get();

    if (targetElement) {
      // Element found, attempt to scroll
      if (smoother) {
        try {
          smoother.scrollTo('#schedule-your-meeting', true, 'top top');
          return; // Success, exit function
        } catch (error) {
          console.warn('ScrollSmoother failed, using fallback:', error);
        }
      }

      // Fallback to native scrolling
      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    } else if (retryCount < maxRetries) {
      // Element not found yet, retry
      retryCount++;
      setTimeout(attemptScroll, retryDelay);
    } else {
      console.warn('Could not find schedule-your-meeting element after maximum retries');
    }
  };

  // Start checking after page load
  setTimeout(attemptScroll, 800);
};

/**
 * Handles the "Book a demo" button click logic
 * Checks if element exists on current page, otherwise navigates to homepage
 */
export const handleBookDemoClick = () => {
  const targetElement = document.getElementById('schedule-your-meeting');

  if (targetElement) {
    // Element exists on current page, scroll to it
    const smoother = ScrollSmoother.get();
    if (smoother) {
      smoother.scrollTo('#schedule-your-meeting', true, 'top top');
    } else {
      targetElement.scrollIntoView({
        behavior: 'smooth'
      });
    }
  } else {
    // Element doesn't exist, navigate to homepage and scroll to it
    navigate('/');
    scrollToScheduleMeeting();
  }
};
